<template>
    <path fill="currentColor" d="M8 1a5 5 0 1 0 0 10A5 5 0 0 0 8 1M5 14.5v-3.303c.883.51 1.907.803 3 .803a6 6 0 0 0 3-.803V14.5a.5.5 0 0 1-.757.429L8 13.583L5.757 14.93A.5.5 0 0 1 5 14.5"/>
</template>
